import React from "react";
import { requiredValidation } from "@via/utils/form-validators.tsx";
import FormInputComponent from "@via/components/inputs/form-input-component.tsx";
import { useForm } from "react-hook-form";
import { ROUTES } from "@via/utils/constants.tsx";
import { useNavigate, useSearchParams } from "react-router-dom";
import { exampleGeoIds } from "@via/pages/data/data-sources/api-data-sources/geo/geo-source.tsx";

interface GeoConnectorForm {
  geoSearchText: string;
}

const GeoConnector: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { control, handleSubmit, setValue } = useForm<GeoConnectorForm>({
    mode: "onChange",
    defaultValues: {
      geoSearchText: "",
    },
  });

  const setExampleGeoId = (geoId: string) => {
    setValue("geoSearchText", geoId);
  };

  const handleGeoConnectionFormSubmit = (payload: GeoConnectorForm) => {
    const datasetId = searchParams.get("datasetId");
    const url = datasetId
      ? `${ROUTES.DATA_SOURCE_PROVIDER_GEO}/${payload.geoSearchText}?datasetId=${datasetId}`
      : `${ROUTES.DATA_SOURCE_PROVIDER_GEO}/${payload.geoSearchText}`;
    navigate(url);
  };

  const handleCancel = (): void => {
    navigate(ROUTES.DATA);
  };

  return (
    <div>
      <form
        onSubmit={e => {
          e.preventDefault();
          handleSubmit(handleGeoConnectionFormSubmit)(e);
        }}>
        <div className="max-w-[850px] mx-auto space-y-6 pb-5 pt-3">
          <div className="max-w-[850px] space-y-6 pb-5 pt-6">
            <FormInputComponent
              name="geoSearchText"
              label="SRA (GEO) accession ID (GSE/GSM/SRR ID):"
              placeholder="GSE/GSM/SRR ID"
              showRequiredField={true}
              control={control}
              validations={requiredValidation("GSE/GSM/SRR ID")}
            />
            <div className="text-sm font-normal text-gray-500">
              Enter a valid comma or space separated SRA(GEO) accession IDs and
              click “Connect”. Foundry will retrieve the corresponding files
              from the SRA GEO database to create a dataset.
              <div className="flex gap-2">
                Example IDs:
                <div>
                  {exampleGeoIds.map(geoId => (
                    <button
                      onClick={() => setExampleGeoId(geoId)}
                      className="font-bold"
                      key={geoId}>
                      {geoId}&nbsp;
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-shrink-0 justify-end py-4">
            <button
              data-testid="geoConnectorCancelButton"
              onClick={handleCancel}
              className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
              Cancel
            </button>
            <button
              data-testid="geoConnectorSubmitButton"
              type="submit"
              className="ml-4 inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              Connect
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
export default GeoConnector;
